import { Validators } from '@angular/forms';
import { MatDateFnsModule } from '@angular/material-date-fns-adapter';
import { MatDialogModule } from '@angular/material/dialog';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyPresetModule } from '@ngx-formly/core/preset';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { FormFieldsAddonsModule } from '@vmspdb/components/form-fields/addons';
import { FormFieldsTestidModule } from '@vmspdb/components/form-fields/testid';
import { StateOptions } from '@vmspdb/ui/domain';

export const formlyModules = [
  FormlyPresetModule,
  FormlyModule.forRoot({
    validators: [
      { name: 'email', validation: Validators.email },
      { name: 'min1', validation: Validators.minLength(1) },
    ],
    presets: [
      {
        name: 'emailField',
        config: {
          key: 'email',
          type: 'input',
          validators: {
            validation: ['email'],
          },
          props: {
            type: 'email',
            label: 'Email address',
            placeholder: 'Enter email',
            required: true,
          },
        },
      },
      {
        name: 'phoneNumberField',
        config: {
          key: 'phoneNumber',
          type: 'input',
          props: {
            type: 'tel',
            label: 'Phone number',
            required: true,
          },
        },
      },
      {
        name: 'addressField',
        config: {
          key: 'address.address',
          type: 'address',
          props: {
            label: 'Address',
            placeholder: '',
            required: true,
          },
        },
      },
      {
        name: 'addressCityField',
        config: {
          key: 'address.city',
          type: 'input',
          props: {
            label: 'City',
            placeholder: '',
            required: true,
          },
        },
      },
      {
        name: 'addressCountyField',
        config: {
          key: 'address.county',
          type: 'input',
          props: {
            label: 'County',
            placeholder: '',
          },
        },
      },
      {
        name: 'addressStateField',
        config: {
          key: 'address.state',
          type: 'select',
          defaultValue: 'KY',
          props: {
            label: 'State',
            placeholder: '',
            required: true,
            options: StateOptions,
          },
        },
      },
      {
        name: 'addressZipField',
        config: {
          key: 'address.zip',
          type: 'input',
          props: {
            label: 'Zip',
            placeholder: '',
            required: true,
            pattern: /^[0-9]{5}(?:-[0-9]{4})?$/,
          },
        },
      },
      {
        name: 'addressComponentsField',
        config: {
          key: 'address.components',
          type: 'input',
          className: 'd-none',
        },
      },
      {
        name: 'moneyField',
        config: {
          type: 'input',
          props: {
            placeholder: '0.00',
            type: 'number',
            step: 0.01,
            min: 0,
            required: true,
            addonLeft: {
              text: '$ ',
            },
          },
        },
      },
    ],
  }),
  FormFieldsAddonsModule,
  FormFieldsTestidModule,
  FormlyMaterialModule,
  FormlyMatDatepickerModule,
  MatDialogModule,
  MatDateFnsModule,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  // MatNativeDateModule,
];
